import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { footerInfo } from '@/mocks/homeData';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            <div className="md:col-span-5">
              <Link to="/" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 inline-block cursor-pointer">
                Mentored<span className="text-accent-500">by Julen</span>
              </Link>
              <p className="text-foreground-700 text-sm leading-relaxed max-w-md mb-8">
                {t('footer.description')}
              </p>
              <div className="flex items-center gap-4">
                {footerInfo.socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:text-primary-600 hover:border-accent-400 hover:bg-accent-50 transition-all duration-200 cursor-pointer"
                    aria-label={social.name}
                  >
                    <i className={`${social.icon} text-base`} />
                  </a>
                ))}
              </div>
            </div>

            <div className="md:col-span-3 md:col-start-7">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-6">
                {t('footer.contact')}
              </h4>
              <div className="space-y-6">
                <div>
                  <p className="text-sm text-foreground-950 leading-relaxed">{t('footer.address')}</p>
                </div>
                <div>
                  <p className="text-sm text-foreground-950">{t('footer.phone')}</p>
                </div>
                <div>
                  <p className="text-sm text-foreground-950">{t('footer.email')}</p>
                </div>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-6">
                {t('footer.quickLinks')}
              </h4>
              <div className="space-y-4">
                <Link to="/services" className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.services')}</Link>
                <Link to="/expertise" className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.expertise')}</Link>
                <Link to="/about" className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.about')}</Link>
                <Link to="/testimonials" className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.testimonials')}</Link>
                <Link to="/booking" className="block text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.bookSession')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="px-6 md:px-10 lg:px-16 py-6">
          <div className="max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.privacy')}</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.terms')}</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">{t('footer.cookies')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}